import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function ResetPassword() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (password !== confirmPassword) {
            return setError('הסיסמאות אינן תואמות');
        }

        setLoading(true);
        try {
            const API_BASE = process.env.REACT_APP_API_URL || '';
            const res = await fetch(`${API_BASE}/api/auth/reset-password/${token}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password })
            });
            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.error || 'אסימון לא תקין או פג תוקף');
            }

            setMessage(data.message);
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4" dir="rtl">
            <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-slate-100 p-8">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-black text-slate-900">יצירת סיסמה חדשה</h2>
                </div>
                {error && <div className="bg-red-50 text-red-600 p-4 rounded-xl text-sm font-bold mb-6 text-center border border-red-100">{error}</div>}
                {message && <div className="bg-green-50 text-green-700 p-4 rounded-xl text-sm font-bold mb-6 text-center border border-green-200">{message} (מעביר להתחברות...)</div>}
                
                {!message && (
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-slate-700 font-bold mb-2 text-sm">סיסמה חדשה</label>
                            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} className="w-full p-3 rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:ring-2 focus:ring-blue-500 outline-none transition-all text-left" dir="ltr" />
                        </div>
                        <div>
                            <label className="block text-slate-700 font-bold mb-2 text-sm">אימות סיסמה</label>
                            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required minLength={6} className="w-full p-3 rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:ring-2 focus:ring-blue-500 outline-none transition-all text-left" dir="ltr" />
                        </div>
                        <button disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-black py-4 rounded-xl transition-all shadow-md mt-6 disabled:bg-blue-400">
                            {loading ? 'מעדכן...' : 'שנה סיסמה'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
